import { Box, Button, Paper, Typography } from '@mui/material';
import type { CreativesViewProps } from '../types';
import type { FC } from 'react';

const CreativeEmptyView: FC<Pick<CreativesViewProps, 'reset'>> = ({ reset }) => {
  return (
    <Box sx={{ p: 2 }}>
      <Paper sx={{ p: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="h6" sx={{fontWeight: 400}}>Nothing found for your request️</Typography>
        <Button variant="outlined" size='small' onClick={reset} sx={{ ml: 2 }}>
          Reset Filters
        </Button>
      </Paper>
    </Box>
  );
};

export default CreativeEmptyView;
